<template>
  <div>{{ formatHourMinute(uuidV7ToTimestamp(observation.id)) }}&nbsp;</div>
  <template v-if="'Measurement' in observation.data && measurementSplitValue">
    <div>{{ measurementDefinition?.definition.name }}</div>
    <span class="integerPart">{{ measurementSplitValue.integerPart }}</span>
    <span class="fractionalPart">{{
      measurementSplitValue.fractionalPart
    }}</span>
    <span class="unit">&nbsp;{{ measurementSplitValue.unit }}</span>
  </template>
  <div v-else-if="'Text' in observation.data" class="text-observation">
    {{ observation.data.Text }}
  </div>
  <div v-else class="raw-observation">{{ observation }}</div>
</template>
<script setup lang="ts">
import type {
  MeasurementDefinitionWithLatestMeasurement,
  Observation,
} from "../gen/observations-vue";
import {
  formatHourMinute,
  type SplitMeasurementValue,
  splitMeasurementValue,
  uuidV7ToTimestamp,
} from "../utils";

const props = defineProps<{
  observation: Observation;
  measurementDefinition: MeasurementDefinitionWithLatestMeasurement | undefined;
}>();

const measurementSplitValue: SplitMeasurementValue | undefined = splitValue();
function splitValue() {
  if ("Measurement" in props.observation.data && props.measurementDefinition) {
    return splitMeasurementValue(
      props.observation.data.Measurement.significand,
      props.measurementDefinition.definition,
    );
  }
  console.log("N0");
  return;
}
</script>
<style scoped>
span.integerPart {
  text-align: right;
  padding-right: 0;
}
span.fractionalPart {
  max-width: min-content;
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  text-align: left;
}
span.unit {
  max-width: min-content;
  text-align: left;
}
div.text-observation {
  grid-column-end: span 4;
}
div.raw-observation {
  grid-column-end: span 4;
}
</style>
